<app-breadcrumb [title]="'accounting system settings' | translate" [items]="['security' | translate]" [active_item]="'accounting system settings' | translate"></app-breadcrumb>

<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card" *ngIf="!isLoading">

                <div class="card-body">
                    <form [formGroup]="accountingSystemSettingsForm" (ngSubmit)="onFormSubmit()" id="ngForm">
                        <!-- Compact Settings Grid -->
                        <div class="row g-4">
                            <!-- Budget Settings Column -->
                            <div class="col-md-6">
                                <div class="settings-card">
                                    <h6 class="settings-card-title">
                                        <i class="fas fa-calculator me-2 text-info"></i>
                                        {{ 'taxes' | translate }}
                                    </h6>
                                    <div class="settings-item">
                                        <div class="mb-3 row">
                                            <label class="col-sm-4">{{ 'periodicity'|translate }}</label>
                                            <div class="col-sm-6">
                                                <ng-select
                                                        [items]="periodicityTaxes"
                                                        bindLabel="name"
                                                        bindValue="id"
                                                        placeholder="{{ 'choose periodicity tax'|translate }}"
                                                        formControlName="periodicityTax"
                                                        [(ngModel)]="periodicityTaxSelected">
                                                </ng-select>
                                            </div>
                                        </div>
                                        <div class="mb-3 row">
                                            <label class="col-sm-4">{{ 'dead line'|translate }} </label>
                                            <div class="col-sm-6">
                                                <input class="form-control form-control-sm" type="text" placeholder="Ex. Km" formControlName="deadline" >

                                            </div>
                                        </div>
                                    </div>
                                    <!--<div class="settings-item">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="autoBudget" formControlName="isBudgetAutomatic">
                                            <label class="form-check-label" for="autoBudget">
                                                {{ 'automatic budget' | translate }}
                                            </label>
                                        </div>
                                        <div class="setting-explanation alert alert-light mt-2 p-2" *ngIf="accountingSystemSettingsForm.get('isBudgetAutomatic')?.value">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'Automatically calculates and allocates budgets based on historical data and predefined rules.' | translate }}
                                            </small>
                                        </div>
                                    </div>-->
                                </div>
                            </div>

                            <!-- Price Settings Column -->
                            <div class="col-md-6">
                                <div class="settings-card">
                                    <h6 class="settings-card-title">
                                        <i class="fas fa-calculator me-2 text-info"></i>
                                        {{ 'currency' | translate }}
                                    </h6>
                                    <div class="settings-item">
                                        <div class="mb-3 row">
                                            <label class="col-sm-4">{{ 'accounting currency'|translate }}</label>
                                            <div class="col-sm-6">
                                                <ng-select
                                                        [items]="accountingCurrencies"
                                                        bindLabel="name"
                                                        bindValue="id"
                                                        placeholder="{{ 'choose currency'|translate }}"
                                                        formControlName="accountingCurrency"
                                                        [(ngModel)]="accountingCurrencySelected">
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- account Settings Column -->
                            <div class="col-md-6">
                                <div class="settings-card">
                                    <h6 class="settings-card-title">
                                        <i class="fas fa-warehouse me-2 text-success"></i>
                                        {{ 'default account' | translate }}
                                    </h6>
                                    <div class="settings-item">
                                        <div class="mb-3 row">
                                            <label class="col-sm-4">{{ 'BankAccount'|translate }}</label>
                                            <div class="col-sm-6">
                                                <ng-select
                                                        [items]="defaultInstitutionBankAccounts"
                                                        bindLabel="name"
                                                        bindValue="id"
                                                        placeholder="{{ 'choose default Institution BankAccount'|translate }}"
                                                        formControlName="defaultInstitutionBankAccount"
                                                        [(ngModel)]="defaultInstitutionBankAccountSelected">
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="settings-item">
                                        <div class="mb-3 row">
                                            <label class="col-sm-4">{{ 'internal payment'|translate }} </label>
                                            <div class="col-sm-6">
                                                <input class="form-control form-control-sm" type="number" placeholder="Ex. Km" formControlName="internalPayment" >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Prepaid expenses Settings Column -->
                            <div class="col-md-6">
                                <div class="settings-card">
                                    <h6 class="settings-card-title">
                                        <i class="fas fa-warehouse me-2 text-success"></i>
                                        {{ 'Prepaid expenses asset' | translate }}
                                    </h6>
                                    <div class="settings-item">
                                        <div class="mb-3 row">
                                            <label class="col-sm-4">{{ 'default journal'|translate }}</label>
                                            <div class="col-sm-6">
                                                <ng-select
                                                        [items]="defaultAssetJournals"
                                                        bindLabel="name"
                                                        bindValue="id"
                                                        placeholder="{{ 'choose default journal'|translate }}"
                                                        formControlName="defaultAssetJournal"
                                                        [(ngModel)]="defaultAssetJournalSelected">
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="settings-item">
                                        <div class="mb-3 row">
                                            <label class="col-sm-4">{{ 'prepaid asset expenses'|translate }} </label>
                                            <div class="col-sm-6">
                                                <input class="form-control form-control-sm" type="text" placeholder="Ex. Km" formControlName="prepaidAssetExpenses" >
                                            </div>
                                        </div>
                                    </div>

                                    <div class="settings-item">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="updateAsset" formControlName="isGenerateEntriesUponInvoiceValidationManuallyLibility">
                                            <label class="form-check-label" for="updateAsset">
                                                {{ 'GenerateEntries Upon Invoice Validation' | translate }}
                                            </label>
                                        </div>
                                        <div class="setting-explanation alert alert-light mt-2 p-2" *ngIf="accountingSystemSettingsForm.get('isGenerateEntriesUponInvoiceValidationManuallyLibility')?.value">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'GenerateEntries Upon Invoice Validation' | translate }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Prepaid expenses Settings Column -->
                            <div class="col-md-6">
                                <div class="settings-card">
                                    <h6 class="settings-card-title">
                                        <i class="fas fa-warehouse me-2 text-success"></i>
                                        {{ 'Prepaid expenses lilbility' | translate }}
                                    </h6>
                                    <div class="settings-item">
                                        <div class="mb-3 row">
                                            <label class="col-sm-4">{{ 'default journal'|translate }}</label>
                                            <div class="col-sm-6">
                                                <ng-select
                                                        [items]="defaultLibilityJournals"
                                                        bindLabel="name"
                                                        bindValue="id"
                                                        placeholder="{{ 'choose default journal'|translate }}"
                                                        formControlName="defaultLibilityJournal"
                                                        [(ngModel)]="defaultLibilityJournalSelected">
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="settings-item">
                                        <div class="mb-3 row">
                                            <label class="col-sm-4">{{ 'prepaid libility expenses'|translate }} </label>
                                            <div class="col-sm-6">
                                                <input class="form-control form-control-sm" type="text" placeholder="Ex. Km" formControlName="prepaidLibilityExpenses" >
                                            </div>
                                        </div>
                                    </div>

                                    <div class="settings-item">
                                        <div class="form-check form-switch">
                                            <input class="form-check-input" type="checkbox" id="updateInventory" formControlName="isGenerateEntriesUponInvoiceValidationManually">
                                            <label class="form-check-label" for="updateInventory">
                                                {{ 'GenerateEntries Upon Invoice Validation' | translate }}
                                            </label>
                                        </div>
                                        <div class="setting-explanation alert alert-light mt-2 p-2" *ngIf="accountingSystemSettingsForm.get('isGenerateEntriesUponInvoiceValidationManually')?.value">
                                            <small><i class="fas fa-info-circle me-1 text-primary"></i>
                                                {{ 'GenerateEntries Upon Invoice Validation' | translate }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Prepaid expenses Settings Column -->
                            <div class="col-md-6">
                                <div class="settings-card">
                                    <h6 class="settings-card-title">
                                        <i class="fas fa-upload me-2 text-success"></i>
                                        {{ 'discounts ' | translate }}
                                    </h6>
                                    <div class="settings-item">
                                        <div class="mb-3 row">
                                            <label class="col-sm-4">{{ 'discount gain anticipated'|translate }} </label>
                                            <div class="col-sm-6">
                                                <input class="form-control form-control-sm" type="text" placeholder="Ex. Km" formControlName="discountGainAnticipated" >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="settings-item">
                                        <div class="mb-3 row">
                                            <label class="col-sm-4">{{ 'loss Of anticipated discount'|translate }} </label>
                                            <div class="col-sm-6">
                                                <input class="form-control form-control-sm" type="text" placeholder="Ex. Km" formControlName="lossOfAnticipatedDiscount" >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- discount Settings Column -->
                            <div class="col-md-6">
                                <div class="settings-card">
                                    <h6 class="settings-card-title">
                                        <i class="fas fa-users me-2 text-warning"></i>
                                        {{ 'Discounts on invoice lines' | translate }}
                                    </h6>
                                    <div class="settings-item">
                                        <div class="mb-3 row">
                                            <label class="col-sm-4">{{ 'customer discount account'|translate }}</label>
                                            <div class="col-sm-6">
                                                <ng-select
                                                        [items]="customerDiscountAccounts"
                                                        bindLabel="name"
                                                        bindValue="id"
                                                        placeholder="{{ 'choose customer discount account'|translate }}"
                                                        formControlName="customerDiscountAccount"
                                                        [(ngModel)]="customerDiscountAccountSelected">
                                                </ng-select>
                                            </div>
                                        </div>
                                        <div class="mb-3 row">
                                            <label class="col-sm-4">{{ 'supplier discount account'|translate }}</label>
                                            <div class="col-sm-6">
                                                <ng-select
                                                        [items]="supplierDiscountAccounts"
                                                        bindLabel="name"
                                                        bindValue="id"
                                                        placeholder="{{ 'choose supplier discount account'|translate }}"
                                                        formControlName="supplierDiscountAccount"
                                                        [(ngModel)]="supplierDiscountAccountSelected">
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div>
									
                                </div>
                            </div>
                            <!-- Revenue accounts  Settings Column -->
                            <div class="col-md-6">
                                <div class="settings-card">
                                    <h6 class="settings-card-title">
                                        <i class="fas fa-users me-2 text-success"></i>
                                        {{ 'Revenue accounts ' | translate }}
                                    </h6>
                                    <div class="settings-item">
                                        <div class="mb-3 row">
                                            <label class="col-sm-4">{{ 'income product account'|translate }}</label>
                                            <div class="col-sm-6">
                                                <ng-select
                                                        [items]="incomeProductAccounts"
                                                        bindLabel="name"
                                                        bindValue="id"
                                                        placeholder="{{ 'choose income product account'|translate }}"
                                                        formControlName="incomeProductAccount"
                                                        [(ngModel)]="incomeProductAccountSelected">
                                                </ng-select>
                                            </div>
                                        </div>
                                        <div class="mb-3 row">
                                            <label class="col-sm-4">{{ 'charge product account'|translate }}</label>
                                            <div class="col-sm-6">
                                                <ng-select
                                                        [items]="chargeProductAccounts"
                                                        bindLabel="name"
                                                        bindValue="id"
                                                        placeholder="{{ 'choose charge product account'|translate }}"
                                                        formControlName="chargeProductAccount"
                                                        [(ngModel)]="chargeProductAccountSelected">
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                <div class="card-footer bg-transparent border-top-0 text-end">
                    <button type="button" class="btn btn-outline-secondary me-2" routerLink="/dashboard/security">
                        <i class="fas fa-times me-2"></i>{{ 'cancel'|translate }}
                    </button>
                    <button form="ngForm" type="submit" class="btn btn-primary" [disabled]="saving">
                        <i class="fas fa-save me-2"></i>
                        <span *ngIf="!saving">{{data ? (update | translate) : (create | translate)}}</span>
                        <span *ngIf="saving">{{ "submitting" | translate }}...</span>
                    </button>
                </div>
            </div>

            <!-- Loading State -->
            <div *ngIf="isLoading" class="card">
                <div class="card-body text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-3 mb-0">{{ 'loading settings' | translate }}</p>
                </div>
            </div>
        </div>
    </div>
</div>